// /src/plugins/IdleTimer.js
import Swal from 'sweetalert2'

export default {
    install(app, options = {}) {
      // Default idle time 30 minutes
      const TIMEOUT_DURATION = options.timeout || 30 * 60 * 1000
      // Default warning time 25 minutes
      const WARNING_DURATION = options.warningTime || 25 * 60 * 1000
      const router = options.router // Must pass Vue Router instance
  
      // Define logout logic for both ends
      const handleIdleTimeoutAdmin = () => {
        Swal.fire({
          title: 'Session Timeout',
          text: 'You have been inactive for 30 minutes. The system will log you out.',
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          localStorage.removeItem('adminToken')
          localStorage.removeItem('Admin')
          router.push('/admin/login')
        })
      }
  
      const handleIdleTimeoutDriver = () => {
        Swal.fire({
          title: 'Session Timeout',
          text: 'You have been inactive for 30 minutes. The system will log you out.',
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          localStorage.removeItem('driverToken')
          localStorage.removeItem('Driver')
          router.push('/auth/login')
        })
      }

      // Warning handler functions
      const showWarningAdmin = () => {
        Swal.fire({
          title: 'Inactivity Warning',
          text: 'You have been inactive for 25 minutes. Please take action within 5 minutes to avoid automatic logout.',
          icon: 'info',
          showConfirmButton: true,
          confirmButtonText: 'Continue',
          showCancelButton: true,
          cancelButtonText: 'Logout'
        }).then((result) => {
          if (result.isConfirmed) {
            resetAdminTimer()
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            handleIdleTimeoutAdmin()
          }
        })
      }

      const showWarningDriver = () => {
        Swal.fire({
          title: 'Inactivity Warning',
          text: 'You have been inactive for 25 minutes. Please take action within 5 minutes to avoid automatic logout.',
          icon: 'info',
          showConfirmButton: true,
          confirmButtonText: 'Continue',
          showCancelButton: true,
          cancelButtonText: 'Logout'
        }).then((result) => {
          if (result.isConfirmed) {
            resetDriverTimer()
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            handleIdleTimeoutDriver()
          }
        })
      }
  
      // Timer IDs for both ends (only start if that end is logged in)
      let adminIdleTimer = null
      let driverIdleTimer = null
      let adminWarningTimer = null
      let driverWarningTimer = null
  
      // Reset admin timer: only start if adminToken exists
      const resetAdminTimer = () => {
        if (adminIdleTimer) {
          clearTimeout(adminIdleTimer)
        }
        if (adminWarningTimer) {
          clearTimeout(adminWarningTimer)
        }
        if (localStorage.getItem('adminToken')) {
          adminWarningTimer = setTimeout(showWarningAdmin, WARNING_DURATION)
          adminIdleTimer = setTimeout(handleIdleTimeoutAdmin, TIMEOUT_DURATION)
        }
      }
  
      // Reset driver timer: only start if driverToken exists
      const resetDriverTimer = () => {
        if (driverIdleTimer) {
          clearTimeout(driverIdleTimer)
        }
        if (driverWarningTimer) {
          clearTimeout(driverWarningTimer)
        }
        if (localStorage.getItem('driverToken')) {
          driverWarningTimer = setTimeout(showWarningDriver, WARNING_DURATION)
          driverIdleTimer = setTimeout(handleIdleTimeoutDriver, TIMEOUT_DURATION)
        }
      }
  
      // Reset both timers
      const resetAllTimers = () => {
        resetAdminTimer()
        resetDriverTimer()
      }
  
      // Define user events to monitor
      const userEvents = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart', 'click', 'input']
      const addEventListeners = () => {
        userEvents.forEach(event => {
          window.addEventListener(event, resetAllTimers)
        })
      }
      const removeEventListeners = () => {
        userEvents.forEach(event => {
          window.removeEventListener(event, resetAllTimers)
        })
        clearTimeout(adminIdleTimer)
        clearTimeout(driverIdleTimer)
        clearTimeout(adminWarningTimer)
        clearTimeout(driverWarningTimer)
      }
  
      // Start global monitoring and timers
      addEventListeners()
      resetAllTimers()
  
      // Mount reset and remove timer methods globally for use in other components (if needed)
      app.config.globalProperties.$resetIdleTimers = resetAllTimers
      app.config.globalProperties.$removeIdleTimers = removeEventListeners
  
      // Remove event listeners before page unload
      window.addEventListener('beforeunload', removeEventListeners)
    }
  }
  